<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-truck-fast icon-primary mt-2"></i>
        <h6 class="ms-2 mb-3">{{ $t('key_orderTrackingInfo_tracking') }}</h6>
      </div>
    </div>
    <div v-if="isLoading" class="pb-0 card-body">
      <div class="tracking-loading"></div>
    </div>
    <div v-else class="pb-0 card-body">
      <div class="timeline timeline-one-side">
        <div v-for="(item) of items" :key="item._id" class="timeline-block mb-3">
          <span class="timeline-step">
            <i :class="getIcon(item)" class="text-secondary"></i>
          </span>
          <div class="timeline-content">
            <h6 class="text-sm font-weight-bold mb-0" :class="getColor(item)">
              {{ getTranslation(item) }}
            </h6>
            <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
              {{ $dateUtils.toDDMMYYYYHH(item.date) }}
            </p>
            <!-- <span v-if="item.status == 'EN_PROCESO'" class="badge badge-sm me-1 bg-gradient-success">
              {{ inProgressPercentage() }}%
            </span> -->
            <soft-button v-if="item.shipment != null" class="mt-2" color="fullfilled" size="sm" @click="goActionTracking(item)">{{ getLabelButton(item) }}</soft-button>
          </div>
        </div>
      </div>
    </div>
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

  import SoftButton from "@/components/SoftButton.vue";

  export default {
    name: "OrderTracking",
    components: {
      SoftButton
    },
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      total: {
        type: Number,
        default: 0
      },
      requestedUnits: {
        type: Number,
        default: 1
      },
      completedUnits: {
        type: Number,
        default: 0
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getIcon(item) {
        const icons = {
          REGISTRADO: "fa-solid fa-circle-info text-saved",
          EDITADO: "fa-solid fa-pen-to-square text-saved",
          EN_PROCESO: "fa-solid fa-box-open text-processing",
          FINALIZADO: "fa-solid fa-box text-fullfilled",
          CANCELADO: "fa-solid fa-xmark text-cancelled",
          RETENIDO: "",
          LIBERADO: "",
          RECUPERADO: "",
          REGISTRADO_OL: "",
          ACTUALIZACION_RESER: "",
          RECIBIDO_ALM: "",
          OUT_OF_STOCK: ""
        };
        return `${icons[item.status] || "fa-solid fa-circle-info"} text-saved`;
      },
      getColor(item) {
        const colors = {
          REGISTRADO: "text-saved",
          EDITADO: "text-saved",
          EN_PROCESO: "text-processing",
          FINALIZADO: "text-fullfilled",
          CANCELADO: "text-cancelled",
          RETENIDO: "",
          LIBERADO: "",
          RECUPERADO: "",
          REGISTRADO_OL: "",
          ACTUALIZACION_RESER: "",
          RECIBIDO_ALM: "",
          OUT_OF_STOCK: ""
        };
        return `${colors[item.status] || "text-saved"}`;
      },
      getTranslation(item) {
        const icons = {
          REGISTRADO: this.$t('key_orderStatus_saved'),
          EDITADO: this.$t('key_orderStatus_edited'),
          EN_PROCESO: this.$t('key_orderStatus_inProcess'),
          FINALIZADO: this.$t('key_orderStatus_finished'),
          CANCELADO: this.$t('key_orderStatus_cancelled'),
          RETENIDO: this.$t('key_orderStatus_onhold'),
          LIBERADO: this.$t('key_orderStatus_resumed'),
          RECUPERADO: this.$t('key_orderStatus_recovered'),
          REGISTRADO_OL: this.$t('key_orderStatus_sga'),
          ACTUALIZACION_RESER: this.$t('key_orderStatus_updatestock'),
          RECIBIDO_ALM: this.$t('key_orderStatus_received'),
          OUT_OF_STOCK: this.$t('key_orderStatus_withoutStock')
        };
        return `${icons[item.status] || this.$t('key_unknown_status')}`;
      },
      inProgressPercentage() {
        return Math.round((this.completedUnits/this.requestedUnits)*100);
      },
      getLabelButton(track) {
        if (track.shipment != null) {
          return this.$t('key_orderTrackingInfo_viewShipment');
        }
        return "Accion No Definida";
      },
      goActionTracking(track){
        this.$router.push({ name: "Shipment detail", params: { id: track.shipment } });
      }
    }
  };

</script>

<style>

  .icon-primary {
    color: #4A7062 !important;
  }

  .tracking-loading {
    height: 8rem;
    background-image: url('../../../assets/img/spinner2.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
  }

</style>